import React, {Component} from 'react';
import {Modal, Button}  from 'react-bootstrap'

import '../Report/report-header.css'
import '../Report/Controls/massedit.css'
import '../commoninputs.css'
import '../Sites/siteadd.css'

export default class ModalSubscriptionAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    this.handleClose = this.handleClose.bind(this);
  }
  componentDidMount() {
    this.initState();
  }
  componentDidUpdate(prevProps) {
  }
  initState () {
  }
  handleClose() {
    this.props.hide();
    this.initState();
  }
  async handleActivateSub(){
    this.props.hide();
    this.props.showStripe();
  }
  renderHeader(title) {
    return (
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
    )    
  }
  render() {

    return(
      <Modal show={this.props.show} onHide={this.handleClose} size="lg">
        {this.renderHeader(this.props.title)}
        <Modal.Body className='body-indent'>
          {this.props.message}
        </Modal.Body>
        <Modal.Footer>
          <div className="modal-error">{this.state.errMsg}</div>
          {this.props.alertType === 0 && <Button className="custom-std-btn" onClick={()=>this.handleClose()}>OK</Button>}
          {this.props.alertType === 1 && <Button className="custom-std-red-btn" onClick={()=>this.handleActivateSub()}>Activate Subscription</Button>}
        </Modal.Footer>
      </Modal>
    )
  }
}